// extracted by mini-css-extract-plugin
module.exports = {"header":"SidePanelHeader_header__3yRLN","text":"SidePanelHeader_text__3GP4f","close":"SidePanelHeader_close__4Xl-A","closeIcon":"SidePanelHeader_closeIcon__3u6bF"};